import { Role } from '../../../../types/auth';

export const getData = (t: (key: string) => string) => [
  {
    title: t('pages:management.users'),
    path: '',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: t('pages:management.vehicles'),
    path: 'vehicles',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: t('pages:management.teams'),
    path: 'teams',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: t('pages:management.groups'),
    path: 'groups',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: t('pages:management.materials'),
    path: 'materials',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: t('pages:management.auxiliaryMachinery'),
    path: 'auxiliar-machinery',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz, Role.Tablet],
  },
  {
    title: t('pages:management.animals'),
    path: 'animals',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    // Tablet y Room-Team fuera by-design: el alta de empresas salió del wizard
    // de Actuación justo para que los roles operativos no ensucien el catálogo.
    title: t('pages:management.externalCompanies'),
    path: 'external-companies',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    // Mismos roles que Empresas externas: es otro catálogo maestro, y existe
    // justo para que el ámbito del recorrido deje de teclearse en carretera.
    title: t('pages:management.routePresets'),
    path: 'route-presets',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: t('pages:management.segmentReview'),
    path: 'segment-review',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: t('pages:management.budgetCategories'),
    path: 'budget-categories',
    permissions: [Role.SuperAdmin, Role.Coex],
  },
  {
    title: t('pages:management.budgetItems'),
    path: 'budget-items',
    permissions: [Role.SuperAdmin, Role.Coex],
  },
];

// Para compatibilidad con imports existentes - usar valores por defecto
export const data = [
  {
    title: 'Usuari',
    path: '',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: 'Vehicles',
    path: 'vehicles',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: 'Equips',
    path: 'teams',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: 'Grups',
    path: 'groups',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: 'Materials',
    path: 'materials',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: 'Maquinària Aux.',
    path: 'auxiliar-machinery',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz, Role.Tablet],
  },
  {
    title: 'Animals',
    path: 'animals',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: 'Empreses externes',
    path: 'external-companies',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: 'Plantilles de recorregut',
    path: 'route-presets',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: 'Revisió de trams',
    path: 'segment-review',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: 'Categories Presup.',
    path: 'budget-categories',
    permissions: [Role.SuperAdmin, Role.Coex],
  },
  {
    title: 'Partides Presup.',
    path: 'budget-items',
    permissions: [Role.SuperAdmin, Role.Coex],
  },
];
